import * as Actions from 'src/_actions/cui'
import initialState from 'src/_store/initialState'

const isQuinePlayingReducer = (
  state = initialState.is_quine_playing,
  action
) => {
  switch (action.type) {
    case Actions.SET_IS_QUINE_PLAYING:
      return action.payload
    default:
      return state
  }
}
export default isQuinePlayingReducer
